export const editableData = [
    {
        name: "Michel Shen",
        id: "USR001",
        application: "Math Genius",
        grade: "A+",
        notes: "",
        avatar: "https://randomuser.me/api/portraits/women/68.jpg",
        updatedDate: "2025-09-15",
        attachment: null, // 👈 store file details
    },
    {
        name: "Maria Lopez",
        id: "USR002",
        application: "Science Lab",
        grade: "A+",
        notes: "",
        avatar: "https://randomuser.me/api/portraits/women/68.jpg",
        updatedDate: "2025-09-14",
        attachment: null,
    },
    {
        name: "Michel Shen",
        id: "USR003",
        application: "Math Genius",
        grade: "A+",
        notes: "",
        avatar: "https://randomuser.me/api/portraits/women/68.jpg",
        updatedDate: "2025-09-15",
        attachment: null, // 👈 store file details
    },
    {
        name: "Maria Lopez",
        id: "USR004",
        application: "Science Lab",
        grade: "A+",
        notes: "",
        avatar: "https://randomuser.me/api/portraits/women/68.jpg",
        updatedDate: "2025-09-14",

        attachment: null,
    },
];
